import { config } from '../../utils/utils';
import store from '../../store';

export interface AgentListItem {
  id: string;
  name: string;
  email: string;
  activeState: boolean;
}

export interface AgentsListResponse {
  total: number;
  limit: number;
  skip: number;
  data: AgentListItem[];
}

/**
 * Get list of agents for dropdown/selection
 * Returns only essential fields: id, name, email
 */
export const getAgentsList = async (
  options?: { search?: string; limit?: number; skip?: number }
): Promise<AgentsListResponse> => {
  try {
    const { accessToken } = store.getState().auth;

    let url = `${config.BASE_URL}/agent-management/list`;
    const params = new URLSearchParams();

    if (options?.search) {
      params.append('search', options.search);
    }
    if (options?.limit) {
      params.append('limit', options.limit.toString());
    }
    if (options?.skip) {
      params.append('skip', options.skip.toString());
    }

    const queryString = params.toString();
    if (queryString) {
      url = `${url}?${queryString}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error: any) {
    console.error('Error fetching agents list:', error);
    throw error;
  }
};

